/* eslint-disable object-curly-newline */
/* eslint-disable nonblock-statement-body-position */
import xdsToken from 'services/xdsToken';
import {
  fetchWithTimeout,
  logDebug,
  retrieveData,
} from 'utils/AuxiliarFunctions';

function catchError(err, from) {
  logDebug(`ERROR in connectorRequests: ${from}: `, err);
  switch (parseInt(err.message, 10)) {
    case 500:
      return 'internal_error';
    case 504:
      return 'timeout';
    case 400:
      return 'bad_request';
    case 401:
      return 'unauthorized';
    case 403:
      return 'forbidden';
    case 404:
    case 410:
      return 'not_found';
    case 409:
      return 'conflict';
    default:
      return 'network_error';
  }
}

async function getTasks(filter) {
  const domain = process.env.REACT_APP_ENDPOINT_XDSB_domain;

  let url = `${domain}/connector/task`;
  if (filter) url = `${url}?${filter}`;

  await xdsToken.getBearerToken();
  const token = await retrieveData('token');
  const applicationToken = await retrieveData('application_token');

  if (!token) return 'missing_token';

  const myHeaders = new Headers();
  myHeaders.append('Authorization', `Bearer ${applicationToken}`);
  myHeaders.append('Content-Type', 'application/fhir+json');
  myHeaders.append('Accept-Encoding', 'gzip,deflate');
  myHeaders.append('Accept', 'application/json');
  myHeaders.append('Content-type', 'application/json');

  const request = {
    method: 'GET',
    headers: myHeaders,
  };

  // logDebug('requestPRINTADO :>> ', request);
  const connectorResponse = await fetchWithTimeout(url, request)
    .then((response) => {
      if (response.status < 200 || response.status > 299)
        throw new Error(response.status);
      return response;
    })
    .catch((err) => catchError(err, 'Connector getTasks'));

  if (typeof connectorResponse === 'string') return connectorResponse;

  const responseJson = await connectorResponse.json();
  return responseJson;
}

async function postTasks({ cnes, instance, model, identifier, patient }) {
  const domain = process.env.REACT_APP_ENDPOINT_XDSB_domain;

  const url = `${domain}/connector/task`;

  await xdsToken.getBearerToken();
  const token = await retrieveData('token');
  const applicationToken = await retrieveData('application_token');

  if (!token) return 'missing_token';

  const myHeaders = new Headers();
  myHeaders.append('Authorization', `Bearer ${applicationToken}`);
  myHeaders.append('Content-Type', 'application/fhir+json');
  myHeaders.append('Accept-Encoding', 'gzip,deflate');
  myHeaders.append('Accept', 'application/json');
  myHeaders.append('Content-type', 'application/json');

  const body = {
    connector: {
      organization: cnes,
      instance,
    },
    action: [
      {
        action: 'reprocess',
        parameters: {
          model,
          identifier,
          patient,
        },
      },
    ],
  };

  const request = {
    method: 'POST',
    headers: myHeaders,
    body: JSON.stringify(body),
  };

  // logDebug('requestPRINTADO :>> ', request);
  const connectorResponse = await fetchWithTimeout(url, request)
    .then((response) => {
      if (response.status < 200 || response.status > 299)
        throw new Error(response.status);
      return response;
    })
    .catch((err) => catchError(err, 'Connector postTasks'));

  if (typeof connectorResponse === 'string') return connectorResponse;

  const responseJson = await connectorResponse.json();
  return responseJson;
}

export const connectorRequests = {
  getTasks,
  postTasks,
};
